import {createApp} from 'vue';
import OrderingTable from './OrderingTable';
import {createBootstrap} from 'bootstrap-vue-next';
import VueMultiselect from 'vue-multiselect';

$(document).ready(/\/faculty-management\/ordering$/.test(window.location.pathname)&&function() {
  const container = $('#ordering-container');

  createApp(OrderingTable, container.data())
     .use(createBootstrap())
      .component('VMultiselect', VueMultiselect)
      .mount(container[0]);
});
